import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ThemeToggleService } from './services/theme-Toggle/theme-toggle.service';
import { HttpClientModule } from '@angular/common/http';
import { ApiService } from './services/common/api.service';
import { AuthService } from './services/auth/auth-service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    HttpClientModule,
    CommonModule,
    RouterOutlet,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [],
})
export class AppComponent {
  constructor(
    private apiService: ApiService,
    private authService: AuthService
  ) { }
  ngOnInit() {
    // Checking session exp time
    // console.log('RELOAD');
    this.authService.initTimer();
    this.apiService.tokenExpiresInSecond.subscribe((value: number) => {
      // console.log('COUNT DOWN: ', value);
      if (value && value <= 15) {
        // console.log('REFRESH MEE');
        this.authService.renewAccessToken();
      }
    });
  }
}
